// Dependency import
import { ZerobounceValidateEmail } from "./_zerobounce-validate-email";
import { GetUTMParams }            from "./_get-utm-params";

// Elements
const FORM = ".js-contact-form";
const FORM_WRAPPER = ".js-contact-form-wrapper";
const FORM_ITEM = ".form-item";
const THANK_YOU = ".js-contact-form-thank-you";
const LOADING_CLASS_NAME = "is-loading";
const SUBMITED_CLASS_NAME = "is-submitted";
const DISABLED_CLASS_NAME = "is-disabled";
const POSITION = ".js-position";
const REGARDING = ".js-regarding";
const ORGANIZATION = ".js-organization";
const DISTRICT = ".js-district";
const STATE = ".js-state";
const COUNTRY = ".js-country";

// Validation options
const VALIDATION_OPTIONS = {
	fields: {
		"position": {
			validators: {
				notEmpty: {
					message: "Please select the option that best applies"
				}
			}
		},
		"firstname": {
			validators: {
				notEmpty: {
					message: "Please enter your first name"
				},
				stringLength: {
					min: 2,
					max: 20,
					message: "The first name must be between 2 and 20 characters long"
				}
			}
		},
		"lastname": {
			validators: {
				notEmpty: {
					message: "Please enter your last name"
				},
				stringLength: {
					min: 2,
					max: 20,
					message: "The last name must be between 2 and 20 characters long"
				}
			}
		},
		"email": {
			validators: {
				notEmpty: {
					message: "Please enter your email address"
				},
				emailAddress: {
					message: "This email format seems wrong"
				},
				remote: {
					message: "Please enter another email address"
				}
			}
		},
		"phone": {
			validators: {
				numeric: {
					message: "The phone number must contain only numbers"
				},
				notEmpty: {
					message: "Please enter your phone number"
				},
				stringLength: {
					min: 7,
					max: 20,
					message: "The phone number must be between 7 and 20 characters long"
				},
				remote: {
					message: "Please enter another phone number"
				}
			}
		},
		"organization": {
			validators: {
				notEmpty: {
					message: "Please enter your company / school name"
				}
			}
		},
		"country": {
			validators: {
				notEmpty: {
					message: "Please select your country"
				}
			}
		},
		"state": {
			validators: {
				notEmpty: {
					message: "Please select your state"
				}
			}
		},
		"district": {
			validators: {
				notEmpty: {
					message: "Please select your district"
				}
			}
		},
		"regarding": {
			validators: {
				notEmpty: {
					message: "Please select the option that best applies"
				}
			}
		},
		"comments": {
			validators: {
				notEmpty: {
					message: "Please let us know how we can help"
				}
			}
		}
	},
	plugins: {
		message: new FormValidation.plugins.Message( {
			clazz: "form-error",
			container: function ( field, element ) {
				return element.closest( ".form-item" );
			}
		} ),
		trigger: new FormValidation.plugins.Trigger()
	}
};

const POSITIONS_FOR_ORGANIZATION = [ "Teacher", "Technology Coordinator", "Curriculum Specialist / Advisor", "Principal", "Superintendent" ];

/**
 * Formhandler
 * @emits "contactusformaction" after form success submission or error
 */
function ContactUs() {

	if ( document.querySelector( FORM ) != null ) {

		const form = document.querySelector( FORM );

		let fv = FormValidation
			.formValidation( form, VALIDATION_OPTIONS );

		fv.disableValidator( "email", "remote" );
		fv.disableValidator( "phone", "remote" );

		const submit = form.querySelector( "[type='submit']" );
		submit.addEventListener( "click", function ( event ) {
			event.preventDefault();

			fv.validate().then( function ( status ) {
				if ( status === "Valid" ) {

					$( FORM ).addClass( LOADING_CLASS_NAME );

					let data = $( FORM ).serialize();

					// Add UTM parameters from string
					data += GetUTMParams();

					// make obj from data
					let urlParams = new URLSearchParams( data );

					let unserializedData = {};
					for ( let [ key, value ] of urlParams ) {
						if ( unserializedData.hasOwnProperty( key ) ) {
							unserializedData[ key ] += ", " + value;
						} else {
							unserializedData[ key ] = value;
						}
					}

					// change country and state to correct values
					unserializedData.country =
						document.getElementById( "country" ).selectedOptions[ 0 ].textContent;

					if ( document.getElementById( "state" ).selectedOptions[ 0 ].textContent.toLowerCase() ==
						 "other" ) {
						unserializedData.state = "";
					} else {
						unserializedData.state =
							document.getElementById( "state" ).selectedOptions[ 0 ].textContent;
					}

					// ZeroBounce API check
					ZerobounceValidateEmail( FORM + " input[name='email']", function ( response ) {
						if ( response.status === "invalid" ) {
							fv.updateFieldStatus( "email", "Invalid", "remote" );
							$( FORM ).removeClass( LOADING_CLASS_NAME );
							const contactusformaction = new CustomEvent( "contactusformaction", {
								detail: {
									action: 'error'
								}
							} );
							document.dispatchEvent( contactusformaction );
						} else {

							unserializedData.zero_bounce_status = response.status;

							if ( $( POSITION ).val() === "Parent / Learner" ) {
								jQuery.ajax( {
									url: gocoderzAjax.url,
									type: "post",
									data: {
										action: "mailchimp_contact_us_submit",
										nonce: gocoderzAjax.nonce,
										formData: unserializedData
									},
									success: function ( response ) {
										$( FORM ).fadeOut();
										$( FORM ).removeClass( LOADING_CLASS_NAME );
										$( THANK_YOU ).fadeIn();
										$( FORM_WRAPPER ).addClass( SUBMITED_CLASS_NAME );
										const contactusformaction = new CustomEvent( "contactusformaction", {
											detail: {
												action: 'success'
											}
										} );
										document.dispatchEvent( contactusformaction );
									},
									error: function ( error ) {
										$( FORM ).fadeOut();
										$( FORM ).removeClass( LOADING_CLASS_NAME );
										$( THANK_YOU ).fadeIn();
										$( FORM_WRAPPER ).addClass( SUBMITED_CLASS_NAME );
										const contactusformaction = new CustomEvent( "contactusformaction", {
											detail: {
												action: 'error'
											}
										} );
										document.dispatchEvent( contactusformaction );
									}
								} );
							} else {
								jQuery.ajax( {
									url: gocoderzAjax.url,
									type: "post",
									data: {
										action: "hubspot_contact_us_submit",
										nonce: gocoderzAjax.nonce,
										formData: unserializedData
									},
									success: function ( response ) {
										if ( response == "success" ) {
											$( FORM ).fadeOut();
											$( FORM ).removeClass( LOADING_CLASS_NAME );
											$( THANK_YOU ).fadeIn();
											$( FORM_WRAPPER ).addClass( SUBMITED_CLASS_NAME );
											const contactusformaction = new CustomEvent( "contactusformaction", {
												detail: {
													action: 'success'
												}
											} );
											document.dispatchEvent( contactusformaction );
										} else if ( response == "INVALID_EMAIL" ) {
											fv.updateFieldStatus( "email", "Invalid", "remote" );
											$( FORM ).removeClass( LOADING_CLASS_NAME );
											const contactusformaction = new CustomEvent( "contactusformaction", {
												detail: {
													action: 'error'
												}
											} );
											document.dispatchEvent( contactusformaction );
										} else if ( response == "NUMBER_OUT_OF_RANGE" ) {
											$( FORM + " input[name='phone']" ).val( "" );
											fv.updateFieldStatus( "phone", "Invalid", "remote" );
											$( FORM ).removeClass( LOADING_CLASS_NAME );
											const contactusformaction = new CustomEvent( "contactusformaction", {
												detail: {
													action: 'error'
												}
											} );
											document.dispatchEvent( contactusformaction );
										} else {
											$( FORM ).removeClass( LOADING_CLASS_NAME );
											console.error( "Error:", error );
											const contactusformaction = new CustomEvent( "contactusformaction", {
												detail: {
													action: 'error'
												}
											} );
											document.dispatchEvent( contactusformaction );
										}
									},
									error: function ( error ) {
										$( FORM ).removeClass( LOADING_CLASS_NAME );
										console.error( "Error:", error );
										const contactusformaction = new CustomEvent( "contactusformaction", {
											detail: {
												action: 'error'
											}
										} );
										document.dispatchEvent( contactusformaction );
									}
								} );
							}
						}
					} );
				}
			} );
		} );

		$( POSITION ).on( "change", function () {
			fv.validateField( "position" );
			if ( POSITIONS_FOR_ORGANIZATION.includes( this.value ) ) {
				$( ORGANIZATION ).removeClass( DISABLED_CLASS_NAME );
				fv.enableValidator( "organization" );
				$( ORGANIZATION + " input" ).prop( "disabled", false );
			} else {
				$( ORGANIZATION ).addClass( DISABLED_CLASS_NAME );
				fv.disableValidator( "organization" );
				$( ORGANIZATION + " input" ).val( "" );
				$( ORGANIZATION + " input" ).prop( "disabled", true );
			}
		} );

		$( REGARDING ).on( "change", function () {
			fv.validateField( "regarding" );
		} );

		$( STATE ).on( "change", function ( e ) {
			fv.validateField( "state" );
		} );

		$( STATE ).on( "select2:select", function ( e ) {
			if ( "OTHER" === e.target.value ) {
				fv.disableValidator( "state" );
			}
		} );

		$( COUNTRY ).on( "change", function ( e ) {
			fv.validateField( "country" );
		} );

		$( COUNTRY ).on( "select2:select", function ( e ) {
			let $parentStateFormItem = $( STATE ).parent( FORM_ITEM );
			if ( "US" === e.target.value ) {
				$parentStateFormItem.removeClass( DISABLED_CLASS_NAME );
			} else {
				$parentStateFormItem.addClass( DISABLED_CLASS_NAME );
			}
		} );
	}
}

export { ContactUs };